// extracted by mini-css-extract-plugin
export default {"cls1":"Zd8mhJ9MtH25mhH9mGd0","cls2":"rAt010f3man9WL4ZwIWC Zd8mhJ9MtH25mhH9mGd0"};